import { Drawer, Row, Space } from "antd";
import { Button, Group, Icon, notification, Title } from "components/common";
import {
  useAddEditNoteMutation,
  useGetNotesMutation,
} from "features/script/api";
import { useEffect, useState } from "react";
import { setScriptsDetailData } from "store/scriptDetailSlice";
import { useDispatch } from "react-redux";
import TextEditor from "components/common/textEditor/textEditor";
import { renderQuillHtml } from "configs/utils";
import theme from "utils/themeVars";

const ScriptNotesSection = ({ open, setOpen, editorTemplateId, notes }) => {
  const [data, setData] = useState(notes || "");
  const dispatch = useDispatch();
  const [addEditNote, { isLoading }] = useAddEditNoteMutation();
  const [isViewMode, setIsViewMode] = useState(!!notes?.note);

  useEffect(() => {
    if (notes) {
      setData(notes);
      setIsViewMode(true);
    }
  }, [notes]);

  const onSave = async () => {
    const res = await addEditNote({
      editor_template_id: editorTemplateId,
      note: data,
    });
    if (res) {
      if (res?.error) {
        notification.error({ message: res?.error });
      } else {
        notification.success({ message: "Notes added successfully" });
        dispatch(setScriptsDetailData({ user_note: data }));
        closeDrawer();
      }
    }
  };

  const closeDrawer = () => {
    setOpen(false);
    setData(notes);
    setIsViewMode(!!notes);
  };

  const onDelete = async () => {
    const res = await addEditNote({
      editor_template_id: editorTemplateId,
      note: " ",
    });
    if (res) {
      if (res?.error) {
        notification.error({ message: res?.error });
      } else {
        notification.success({ message: "Notes deleted successfully" });
        closeDrawer();
      }
    }
  };

  return (
    <Drawer
      closable={false}
      placement="right"
      style={{ marginTop: "72px" }}
      open={open}
      extra={
        <Icon className="pointer" icon="IoMdClose" onClick={closeDrawer} />
      }
      footer={
        <Row justify="end">
          <Space>
            <Button
              className="pi-12"
              style={{ "--btn-bg": "#9d9d9d" }}
              onClick={closeDrawer}
              bordered
            >
              Cancel
            </Button>
            <Button
              onClick={onSave}
              type="primary"
              text={!!notes ? "Update Notes" : "Add Notes"}
              className="pi-12"
              loading={isLoading}
              disabled={isViewMode}
            />
          </Space>
        </Row>
      }
    >
      <Group>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Icon
              icon="IoMdClose"
              onClick={closeDrawer}
              className="pointer"
              style={{ fontSize: "20px" }}
            />
            <Title level={2}>Notes</Title>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Icon
              icon="BiEdit"
              onClick={() => setIsViewMode(false)}
              className="pointer"
              style={{ fontSize: "20px" }}
              color={theme["primary-color"]}
            />
            {/* add when removed check from BE of notes cant be empty */}
            {/* <Icon 
              icon="MdDeleteForever"
              onClick={onDelete}
              className="pointer"
              style={{ fontSize: "20px" }}
              color={theme["error-color"]}
            /> */}
          </div>
        </div>
        {!isViewMode ? (
          <TextEditor
            key={"user-script-notes"}
            placeholder={"Add Your Notes here"}
            value={data}
            onChange={(value) => {
              setData(value);
            }}
            editorHeight={550}
          />
        ) : (
          renderQuillHtml(data)
        )}
      </Group>
    </Drawer>
  );
};

export default ScriptNotesSection;
